import { useLocation, useNavigate } from "react-router-dom";
import React, { Fragment, useEffect, useState } from "react";
import { ApiCallStatus } from "../../utils/constants";
import { fetchAddressCheckoutData } from "../PageFunctions/checkoutFunctions";
import _ from "lodash";
import { Alert, Backdrop, CircularProgress, Container } from "@mui/material";
import CreateAddress from "../../components/CreateAddress";
import { useArgusAuth } from "../../hooks/useArgusAuth";


const CheckoutCreateAddressPage = ({
	genericDataLoaded,
	genericPageContent
}) => {
	const {isLoading} = useArgusAuth();
	const location = useLocation();
	const navigate = useNavigate();
	const [addressCheckoutInfo, setAddressCheckoutInfo] = useState(null);
	const [countries, setCountries] = useState([]);
	const [provinces, setProvinces] = useState([]);
	const [createAddressErrorMessage, setCreateAddressErrorMessage] = useState("");

	const [addressCheckoutInfoCallStatus, setAddressCheckoutInfoCallStatus] = useState(ApiCallStatus.NotStarted);

	const fetchCheckoutAddressDataAsync = async () => {
		await fetchAddressCheckoutData({
			setAddressCheckoutInfo,
			setStatusInProgress: () => setAddressCheckoutInfoCallStatus(ApiCallStatus.InProgress),
			setStatusSuccess: () => setAddressCheckoutInfoCallStatus(ApiCallStatus.Succeeded),
			setStatusFailed: () => setAddressCheckoutInfoCallStatus(ApiCallStatus.Failed),
			setStatusError: () => setAddressCheckoutInfoCallStatus(ApiCallStatus.Error)
		});
	};

	const unAuthorizedPageLoad = async () => {
		await Promise.all([
			fetchCheckoutAddressDataAsync()
		]);
	};

	const scrollTop = () => {
		window.scrollTo(0, 0);
	};

	const handleCreateNewAddressSuccess = () => {
		let pathName = location.pathname;
		pathName = _.replace(pathName, "/create", "");
		navigate(pathName);
	};

	const handleCreateNewAddressFailure = () => {
		setCreateAddressErrorMessage("We could not save your address. Please check the details below and try again.");
		scrollTop();
	}

	useEffect(() => {
		scrollTop();
	}, []);

	useEffect(() => {
		if (genericDataLoaded === true && isLoading === false) {
			unAuthorizedPageLoad();
		}

	}, [genericDataLoaded, isLoading]);

	useEffect(() => {
		if (!!addressCheckoutInfo) {
			let countries = [];
			let provinces = [];

			if (addressCheckoutInfo?.countries) {
				const countriesInAlphabeticalOrder = _.sortBy(
					addressCheckoutInfo.countries,
					({name}) => name
				);
				countries = _.sortBy(countriesInAlphabeticalOrder, ({name}) =>
					name === "South Africa" ? 0 : 1
				);
			}

			if (addressCheckoutInfo?.provinces) {
				provinces = addressCheckoutInfo.provinces;
			}

			setProvinces(provinces);
			setCountries(countries);
		}
	}, [addressCheckoutInfo]);

	const allLoadingStates = [
		addressCheckoutInfoCallStatus
	];

	const pageIsLoading = allLoadingStates.includes(ApiCallStatus.InProgress) || genericDataLoaded === false || isLoading === true;

	return (
		<Container maxWidth="lg">
			{!!createAddressErrorMessage && (
				<Alert severity="warning" sx={{mt: 2, mb: 2}}>
					{createAddressErrorMessage}
				</Alert>
			)}
			<CreateAddress
				countries={countries}
				provinces={provinces}
				email={genericPageContent?.email}
				closeWithSuccess={handleCreateNewAddressSuccess}
				closeWithFailure={handleCreateNewAddressFailure}
			/>
			<Backdrop
				sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
				open={pageIsLoading}
			>
				<CircularProgress color="inherit"/>
			</Backdrop>
		</Container>
	);
}

export default CheckoutCreateAddressPage;